<template>
  <div>
    <!-- ============ SIDEBAR ============ -->
    <v-navigation-drawer
      v-model="drawer"
      clipped
      app
      v-if="usuarioLogado"
      :color="$vuetify.theme.dark ? '#1b1519' : 'white'"
      :permanent="!isMobile"
      :temporary="isMobile"
      :expand-on-hover="!isMobile"
      width="262"
      mini-variant-width="68"
      class="tp-side"
    >
      <!-- logo da igreja -->
      <div class="tp-side__brand">
        <v-img v-if="companyobj.logoUrl" :src="companyobj.logoUrl" max-height="56" contain></v-img>
        <img v-else :src="$vuetify.theme.dark ? require('../assets/logoTemplusBranca.png') : require('../assets/logoTemplus.png')" alt="Templus" :style="{ maxHeight: '40px', mixBlendMode: $vuetify.theme.dark ? 'normal' : 'multiply' }" />
      </div>

      <v-list nav dense class="tp-side__list">
        <!-- Dashboard -->
        <v-list-item to="/home" active-class="tp-active" class="tp-item">
          <v-list-item-icon><v-icon>mdi-view-dashboard-outline</v-icon></v-list-item-icon>
          <v-list-item-content><v-list-item-title>Dashboard</v-list-item-title></v-list-item-content>
        </v-list-item>

        <!-- Igrejas (apenas admin geral Templus — não vinculado a uma igreja) -->
        <v-list-item to="/igrejas" active-class="tp-active" class="tp-item" v-if="user.tipo == 'ADMIN' && !user.igrejaId">
          <v-list-item-icon><v-icon>mdi-church</v-icon></v-list-item-icon>
          <v-list-item-content><v-list-item-title>Igrejas</v-list-item-title></v-list-item-content>
        </v-list-item>

        <!-- Auditoria (apenas admin geral Templus — não vinculado a uma igreja) -->
        <v-list-item to="/auditoria" active-class="tp-active" class="tp-item" v-if="user.tipo == 'ADMIN' && !user.igrejaId">
          <v-list-item-icon><v-icon>mdi-clipboard-text-clock-outline</v-icon></v-list-item-icon>
          <v-list-item-content><v-list-item-title>Auditoria</v-list-item-title></v-list-item-content>
        </v-list-item>

        <!-- Redes -->
        <v-list-item to="/relrede" active-class="tp-active" class="tp-item" v-if="user.tipo == 'GERENTE' || user.tipo == 'ADMIN' || user.tipo =='BACKUP'">
          <v-list-item-icon><v-icon>mdi-set-none</v-icon></v-list-item-icon>
          <v-list-item-content><v-list-item-title>Redes</v-list-item-title></v-list-item-content>
        </v-list-item>

        <!-- Células -->
        <v-list-item to="/relcelula" active-class="tp-active" class="tp-item" v-if="user.tipo == 'GERENTE' || user.tipo == 'ADMIN' || user.tipo =='BACKUP'">
          <v-list-item-icon><v-icon>mdi-account-multiple-outline</v-icon></v-list-item-icon>
          <v-list-item-content><v-list-item-title>Células</v-list-item-title></v-list-item-content>
        </v-list-item>

        <!-- Profissionais -->
        <v-list-item to="/relprofissionais" active-class="tp-active" class="tp-item" v-if="user.tipo == 'GERENTE' || user.tipo == 'ADMIN' || user.tipo =='BACKUP'">
          <v-list-item-icon><v-icon>mdi-account-tie</v-icon></v-list-item-icon>
          <v-list-item-content><v-list-item-title>Profissionais</v-list-item-title></v-list-item-content>
        </v-list-item>

        <!-- Serviços: tela mantida (rota /servicos), mas não exibida no menu.
             O catálogo é importado automaticamente por padrão. -->

        <!-- Minha Igreja (oculto para a Igreja da Liberdade) -->
        <v-list-item to="/minhaigreja" active-class="tp-active" class="tp-item" v-if="(user.tipo == 'GERENTE' || user.tipo == 'ADMIN') && user.igrejaId && user.igrejaId != '6390de5538a3bc18300a2022'">
          <v-list-item-icon><v-icon>mdi-church</v-icon></v-list-item-icon>
          <v-list-item-content><v-list-item-title>Minha Igreja</v-list-item-title></v-list-item-content>
        </v-list-item>

        <!-- Pessoas -->
        <v-list-group color="#00695C" class="tp-group" v-if="user.tipo == 'GERENTE' || user.tipo == 'ADMIN' || user.tipo == 'LIDER' || user.tipo =='BACKUP'">
          <template v-slot:activator>
            <v-list-item-icon><v-icon>mdi-account-group</v-icon></v-list-item-icon>
            <v-list-item-content><v-list-item-title>Pessoas</v-list-item-title></v-list-item-content>
          </template>
          <v-list-item to="/relliderrede" active-class="tp-active" class="tp-item tp-item--sub" v-if="user.tipo == 'GERENTE' || user.tipo == 'ADMIN' || user.tipo == 'LIDER' || user.tipo =='BACKUP'">
            <v-list-item-content><v-list-item-title>Líderes de Rede</v-list-item-title></v-list-item-content>
          </v-list-item>
          <v-list-item to="/relsupervisor" active-class="tp-active" class="tp-item tp-item--sub" v-if="user.tipo == 'GERENTE' || user.tipo == 'ADMIN' || user.tipo == 'LIDER' || user.tipo =='BACKUP'">
            <v-list-item-content><v-list-item-title>Supervisores</v-list-item-title></v-list-item-content>
          </v-list-item>
          <v-list-item to="/rellidercelula" active-class="tp-active" class="tp-item tp-item--sub" v-if="user.tipo == 'GERENTE' || user.tipo == 'ADMIN' || user.tipo == 'LIDER' || user.tipo =='BACKUP'">
            <v-list-item-content><v-list-item-title>Líderes de Célula</v-list-item-title></v-list-item-content>
          </v-list-item>
          <v-list-item to="/relmembros" active-class="tp-active" class="tp-item tp-item--sub" v-if="user.tipo == 'GERENTE' || user.tipo == 'ADMIN' || user.tipo == 'LIDER' || user.tipo =='BACKUP'">
            <v-list-item-content><v-list-item-title>Membros/Congregados</v-list-item-title></v-list-item-content>
          </v-list-item>
        </v-list-group>

        <!-- Kids -->
        <v-list-group color="#00695C" class="tp-group">
          <template v-slot:activator>
            <v-list-item-icon><v-icon>mdi-teddy-bear</v-icon></v-list-item-icon>
            <v-list-item-content><v-list-item-title>Kids</v-list-item-title></v-list-item-content>
          </template>
          <v-list-item to="/relmembroskids" active-class="tp-active" class="tp-item tp-item--sub" v-if="user.tipo == 'GERENTE' || user.tipo == 'ADMIN' || user.tipo == 'LIDER' || user.tipo =='BACKUP'">
            <v-list-item-content><v-list-item-title>Lista Crianças</v-list-item-title></v-list-item-content>
          </v-list-item>
          <!-- Turmas (Kids) — oculto para a Igreja da Liberdade -->
          <v-list-item to="/turmas" active-class="tp-active" class="tp-item tp-item--sub" v-if="(user.tipo == 'GERENTE' || user.tipo == 'ADMIN' || user.tipo == 'EVENTO' || user.tipo =='BACKUP') && user.igrejaId && user.igrejaId != '6390de5538a3bc18300a2022'">
            <v-list-item-content><v-list-item-title>Turmas</v-list-item-title></v-list-item-content>
          </v-list-item>
          <v-list-item to="/membroturma" active-class="tp-active" class="tp-item tp-item--sub" v-if="user.tipo == 'GERENTE' || user.tipo == 'ADMIN' || user.tipo == 'EVENTO' || user.tipo =='BACKUP'">
            <v-list-item-content><v-list-item-title>Culto Infantil</v-list-item-title></v-list-item-content>
          </v-list-item>
          <v-list-item to="/escolabiblica" active-class="tp-active" class="tp-item tp-item--sub" v-if="user.tipo == 'GERENTE' || user.tipo == 'ADMIN' || user.tipo == 'EVENTO'  || user.tipo =='BACKUP'">
            <v-list-item-content><v-list-item-title>Escola Bíblica</v-list-item-title></v-list-item-content>
          </v-list-item>
        </v-list-group>

        <!-- Voluntários -->
        <v-list-group color="#00695C" class="tp-group">
          <template v-slot:activator>
            <v-list-item-icon><v-icon>mdi-hand-heart</v-icon></v-list-item-icon>
            <v-list-item-content><v-list-item-title>Voluntários</v-list-item-title></v-list-item-content>
          </template>
          <v-list-item to="/relministerios" active-class="tp-active" class="tp-item tp-item--sub" v-if="user.tipo == 'GERENTE' || user.tipo == 'ADMIN' || user.tipo == 'LIDER' || user.tipo =='BACKUP'">
            <v-list-item-content><v-list-item-title>Ministérios</v-list-item-title></v-list-item-content>
          </v-list-item>
          <v-list-item to="/voluntarios" active-class="tp-active" class="tp-item tp-item--sub" v-if="user.tipo == 'GERENTE' || user.tipo == 'ADMIN' || user.tipo == 'EVENTO' || user.tipo =='BACKUP'">
            <v-list-item-content><v-list-item-title>Inscritos</v-list-item-title></v-list-item-content>
          </v-list-item>
        </v-list-group>

        <!-- Escola Ministerial -->
        <v-list-group color="#00695C" class="tp-group">
          <template v-slot:activator>
            <v-list-item-icon><v-icon>mdi-school</v-icon></v-list-item-icon>
            <v-list-item-content><v-list-item-title>Escola Ministerial</v-list-item-title></v-list-item-content>
          </template>
          <v-list-item to="/eventos" active-class="tp-active" class="tp-item tp-item--sub" v-if="user.tipo == 'GERENTE' || user.tipo == 'ADMIN' || user.tipo == 'LIDER' || user.tipo =='BACKUP'">
            <v-list-item-content><v-list-item-title>Turmas</v-list-item-title></v-list-item-content>
          </v-list-item>
          <v-list-item to="/inscricoes" active-class="tp-active" class="tp-item tp-item--sub" v-if="user.tipo == 'GERENTE' || user.tipo == 'ADMIN' || user.tipo == 'EVENTO' || user.tipo =='BACKUP'">
            <v-list-item-content><v-list-item-title>Inscritos</v-list-item-title></v-list-item-content>
          </v-list-item>
        </v-list-group>

        <!-- Ação Social -->
        <v-list-group color="#00695C" class="tp-group">
          <template v-slot:activator>
            <v-list-item-icon><v-icon>mdi-heart-outline</v-icon></v-list-item-icon>
            <v-list-item-content><v-list-item-title>Ação Social</v-list-item-title></v-list-item-content>
          </template>
          <v-list-item to="/programa" active-class="tp-active" class="tp-item tp-item--sub" v-if="user.tipo == 'GERENTE' || user.tipo == 'ADMIN' || user.tipo == 'LIDER' || user.tipo =='BACKUP'">
            <v-list-item-content><v-list-item-title>Programas</v-list-item-title></v-list-item-content>
          </v-list-item>
          <v-list-item to="/beneficiario" active-class="tp-active" class="tp-item tp-item--sub" v-if="user.tipo == 'GERENTE' || user.tipo == 'ADMIN' || user.tipo == 'EVENTO' || user.tipo =='BACKUP'">
            <v-list-item-content><v-list-item-title>Beneficiários</v-list-item-title></v-list-item-content>
          </v-list-item>
          <v-list-item to="/historico" active-class="tp-active" class="tp-item tp-item--sub" v-if="user.tipo == 'GERENTE' || user.tipo == 'ADMIN' || user.tipo == 'EVENTO' || user.tipo =='BACKUP'">
            <v-list-item-content><v-list-item-title>Histórico</v-list-item-title></v-list-item-content>
          </v-list-item>
        </v-list-group>
      </v-list>

      <template v-slot:append>
        <div class="tp-side__append">
          <v-list-item href="https://api.whatsapp.com/send/?phone=558335125222" target="_blank" class="tp-item">
            <v-list-item-icon><v-icon>mdi-face-agent</v-icon></v-list-item-icon>
            <v-list-item-content><v-list-item-title>Suporte</v-list-item-title></v-list-item-content>
          </v-list-item>
          <v-list-item @click="Sair()" class="tp-item tp-item--exit">
            <v-list-item-icon><v-icon>mdi-logout</v-icon></v-list-item-icon>
            <v-list-item-content><v-list-item-title>Sair</v-list-item-title></v-list-item-content>
          </v-list-item>
        </div>
      </template>
    </v-navigation-drawer>

    <!-- ============ TOPBAR ============ -->
    <v-app-bar
      app
      clipped-left
      flat
      v-if="usuarioLogado"
      :color="$vuetify.theme.dark ? '#1b1519' : 'white'"
      height="64"
      class="tp-topbar"
    >
      <v-app-bar-nav-icon v-if="isMobile" @click.stop="drawer = !drawer" :color="$vuetify.theme.dark ? 'white' : '#16322E'"></v-app-bar-nav-icon>
      <span class="tp-page-title">{{ pageTitle }}</span>

      <v-spacer></v-spacer>

      <!-- TOGGLE TEMA CLARO/ESCURO -->
      <v-btn icon @click="toggleTema" :title="$vuetify.theme.dark ? 'Tema claro' : 'Tema escuro'">
        <v-icon :color="$vuetify.theme.dark ? '#FFD54F' : '#16322E'">{{ $vuetify.theme.dark ? 'mdi-white-balance-sunny' : 'mdi-weather-night' }}</v-icon>
      </v-btn>

      <!-- MENU USUÁRIO -->
      <v-menu bottom offset-y min-width="220">
        <template v-slot:activator="{ on }">
          <v-btn icon v-on="on">
            <v-avatar size="40" color="#00695C">
              <v-img v-if="user.imagem" :src="user.imagem"></v-img>
              <span v-else class="tp-avatar-initials">{{ iniciais }}</span>
            </v-avatar>
          </v-btn>
        </template>
        <v-list dense>
          <v-list-item>
            <v-list-item-avatar color="#00695C">
              <v-img v-if="user.imagem" :src="user.imagem"></v-img>
              <span v-else class="tp-avatar-initials">{{ iniciais }}</span>
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title style="font-weight: 600;color:#16322E;">{{ user.nome }}</v-list-item-title>
              <v-list-item-subtitle>{{ companyobj.nome }}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>

          <v-divider></v-divider>

          <v-list-item href="https://api.whatsapp.com/send/?phone=558335125222&text=Olá,%20quero%20enviar%20uma%20sugestão%20sobre%20o%20Templus" target="_blank">
            <v-list-item-icon class="mr-3"><v-icon small>mdi-lightbulb-on-outline</v-icon></v-list-item-icon>
            <v-list-item-title>Enviar sugestão</v-list-item-title>
          </v-list-item>

          <v-divider></v-divider>

          <v-list-item @click="Sair()">
            <v-list-item-icon class="mr-3"><v-icon small color="error">mdi-logout</v-icon></v-list-item-icon>
            <v-list-item-title>Sair</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-app-bar>
  </div>
</template>

<script>
  import { mapState } from 'vuex'

  export default {
    props: {
      source: String,
    },
    data() {
      return {
        drawer: null,
      }
    },

    mounted: function () {
      if (sessionStorage.getItem('accToken') != null)
        this.$store.dispatch('Logar', this.token)
      if (sessionStorage.getItem('user') != null)
        this.$store.dispatch('SetUser')
      if (sessionStorage.getItem('company') != null)
        this.$store.dispatch('SetCompany')
      // restaura preferência de tema (claro/escuro)
      this.$vuetify.theme.dark = localStorage.getItem('tp-theme') === 'dark'
    },

    computed: {
      ...mapState({
        usuarioLogado: state => state.isMenuVisible,
        user: state => state.userObj,
        companyobj: state => state.companyObj,
      }),
      isMobile() {
        return !this.$vuetify.breakpoint.mdAndUp
      },
      pageTitle() {
        const map = {
          home: 'Dashboard', igrejas: 'Igrejas', relrede: 'Redes', relcelula: 'Células',
          relprofissionais: 'Profissionais', servicos: 'Serviços', relliderrede: 'Líderes de Rede', relsupervisor: 'Supervisores',
          rellidercelula: 'Líderes de Célula', relmembros: 'Membros e Congregados',
          relmembroskids: 'Lista de Crianças', membroturma: 'Culto Infantil', escolabiblica: 'Escola Bíblica',
          relministerios: 'Ministérios', voluntarios: 'Voluntários', eventos: 'Turmas', inscricoes: 'Inscritos',
          programa: 'Programas', beneficiario: 'Beneficiários', historico: 'Histórico', relturma: 'Turmas',
          auditoria: 'Auditoria', minhaigreja: 'Minha Igreja',
        }
        return map[this.$route.name] || 'Templus'
      },
      iniciais() {
        const n = (this.user && this.user.nome) ? String(this.user.nome).trim() : ''
        if (!n) return 'U'
        const p = n.split(' ').filter(Boolean)
        const a = (p[0] || '')[0] || ''
        const b = p.length > 1 ? (p[p.length - 1][0] || '') : ''
        return (a + b).toUpperCase()
      },
    },

    methods: {
      toggleTema() {
        this.$vuetify.theme.dark = !this.$vuetify.theme.dark
        localStorage.setItem('tp-theme', this.$vuetify.theme.dark ? 'dark' : 'light')
      },
      Sair() {
        this.$store.dispatch('Sair')
        this.$router.push({ path: '/login' })
      },
    }
  }
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Fraunces:opsz,wght@9..144,500;9..144,600&display=swap');

/* sidebar */
.tp-side { border-right: 1px solid #e6efec; }
.tp-side__brand {
  display: flex; align-items: center; justify-content: center;
  padding: 16px 14px; min-height: 76px; border-bottom: 1px solid #eef3f1;
}
.tp-side__list { padding: 12px 10px; }
.tp-side__append { padding: 8px 10px 12px; border-top: 1px solid #eef3f1; }

/* rail mini (desktop): marca compacta e ícones centralizados */
.tp-side.v-navigation-drawer--mini-variant .tp-side__brand { padding: 12px 0; min-height: 64px; }
.tp-side.v-navigation-drawer--mini-variant .tp-side__brand img,
.tp-side.v-navigation-drawer--mini-variant .tp-side__brand >>> .v-image { max-height: 34px !important; max-width: 46px; }

.tp-item { border-radius: 12px !important; margin-bottom: 2px; }
.tp-item .v-list-item__icon .v-icon { color: #6b7b76; }
.tp-item .v-list-item__title { color: #2b3a36; font-weight: 500; font-size: .93rem; }
.tp-item--sub .v-list-item__title { color: #5b6b67; font-weight: 500; }
.tp-item:hover { background: #f1f6f4; }
.tp-item--exit .v-list-item__icon .v-icon,
.tp-item--exit .v-list-item__title { color: #d2544c; }

/* item ativo (pill teal) */
.tp-active { background: rgba(0,105,92,.10) !important; }
.tp-active::before { opacity: 0 !important; }
.tp-active .v-list-item__icon .v-icon { color: #00695C !important; }
.tp-active .v-list-item__title { color: #00695C !important; font-weight: 700 !important; }

/* grupos */
.tp-group >>> .v-list-group__header { border-radius: 12px !important; }
.tp-group >>> .v-list-group__header .v-list-item__icon .v-icon { color: #6b7b76; }
.tp-group >>> .v-list-group__header .v-list-item__title { color: #2b3a36; font-weight: 600; font-size: .93rem; }

/* topbar */
.tp-topbar { border-bottom: 1px solid #e6efec !important; }
.tp-page-title {
  font-family: 'Fraunces', Georgia, serif; font-weight: 600; font-size: 1.35rem;
  color: #16322E; margin-left: 6px; letter-spacing: -0.01em;
}
.tp-avatar-initials { color: #fff; font-weight: 700; font-size: .9rem; }
</style>
